import { RootState } from 'shared/config/store'

export const selectBoardsSharingBoardDataSelector = (state: RootState) => state.sharing.sharedItemData

export const selectBoardsSharingDataExpiresSelector = (state: RootState) => state.sharing.sharingData?.expires

export const selectBoardsSharingDataSelector = (state: RootState) => state.sharing.sharingData

export const selectBoardsSharingCollaboratorsSelector = (state: RootState) => state.sharing.collaborators

export const selectBoardsSharingConfigSelector = (state: RootState) => state.sharing.config

export const selectBoardsSharingAvailableTypesPublicLinkSelector = (state: RootState) => state.sharing.availableTypesPublicLink

export const selectBoardsSharingIsBusySelector = (state: RootState) => state.sharing.isBusy

export const selectBoardsSharingToggleSettingsSelector = (state: RootState) => state.sharing.toggleSharingSettings

export const selectBoardsSharingSettingsEnabledSelector = (state: RootState) => state.sharing.sharingSettingsEnabled

export const selectCollaborators = (state: RootState) => state.sharing.collaborators
